import { render, staticRenderFns } from "./PStatus.vue?vue&type=template&id=796c826f"
import script from "./PStatus.vue?vue&type=script&lang=js"
export * from "./PStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports